import { AfterContentInit, Component, ContentChildren, ElementRef, HostBinding, OnInit, QueryList, Renderer2, ViewEncapsulation, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FuseWidgetToggleDirective } from './widget-toggle.directive';

@Component({
    selector: 'fuse-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class FuseWidgetComponent implements OnInit, AfterContentInit {
    @HostBinding('class.flipped') flipped = false;
    @Output() flip = new EventEmitter();
    @ContentChildren(FuseWidgetToggleDirective, { descendants: true }) toggleButtons: QueryList<FuseWidgetToggleDirective>;

    constructor(private el: ElementRef, private renderer: Renderer2, private cd: ChangeDetectorRef) {
    }

    ngOnInit() {

    }

    ngAfterContentInit() {
        setTimeout(() => {

            this.toggleButtons.forEach(flipButton => {
                this.renderer.listen(flipButton.el.nativeElement, 'click', () => {
                    this.toggle();
                });
            });
        });
    }

    toggle() {
        this.flipped = !this.flipped;
        this.flip.emit(this.flipped);
        this.cd.markForCheck();
    }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/widget/widget.component.ts